import { render } from "./FooterComp.vue?vue&type=template&id=2f2cba1f&scoped=true"
import script from "./FooterComp.vue?vue&type=script&scoped=true&lang=js"
export * from "./FooterComp.vue?vue&type=script&scoped=true&lang=js"

import "./FooterComp.vue?vue&type=style&index=0&id=2f2cba1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2cba1f"]])

export default __exports__